<template>
  <div
    class="carousel__item-text san-richtext"
    :class="{ 'carousel__item-text--active': isActive }"
    v-html="item.text || ''"
  />
</template>

<script>
export default {
  name: 'SanitasCarouselItemText',

  props: {
    item: {
      type: Object,
      required: true,
      // Props:
      //   text: String
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="postcss" scoped>
.carousel__item-text {
  opacity: 0;
  transition: opacity var(--dotcom-carousel-transition-duration) ease;

  .carousel__stack__item--active & {
    opacity: 1;
  }

  & >>> h3 {
    font-size: 15px;
    line-height: 1.2;
  }

  & >>> ul {
    list-style-type: disc;

    ul {
      list-style-type: circle;
    }
  }
}
</style>
